import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { GraphService } from './graph.service';

interface PassengerFields {
  id?: boolean;
  address?: boolean;
  age?: boolean;
  alergias?: boolean;
  city?: boolean;
  country?: boolean;
  dateOfBirth?: boolean;
  dateOfPass?: boolean;
  doe?: boolean;
  email?: boolean;
  firstName?: boolean;
  gender?: boolean;
  height?: boolean;
  idItinerary?: boolean;
  isTC?: boolean;
  lastName?: boolean;
  passportNumber?: boolean;
  phone?: boolean;
  restriccionesAlimentarias?: boolean;
  condicionesMedicas?: boolean;
  size?: boolean;
  status?: boolean;
  weight?: boolean;
  createdAt?: boolean;
  updatedAt?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(
    private http: HttpClient,
    private queryGQL: GraphService,
  ) {}

  itinerarios: any[] = [
    {
      id: 1,
      nombre: 'Plato1',
      categoria: 'A',
      observaciones: 'Observación 1',
      costo: '20.50',
    },
    {
      id: 2,
      nombre: 'Plato2',
      categoria: 'B',
      observaciones: 'Observación 2',
      costo: '10.50',
    },
    {
      id: 3,
      nombre: 'Plato3',
      categoria: 'C',
      observaciones: 'Observación 3',
      costo: '22.10',
    },
    {
      id: 4,
      nombre: 'Plato4',
      categoria: 'D',
      observaciones: 'Observación 4',
      costo: '20.50',
    },
    {
      id: 5,
      nombre: 'Plato5',
      categoria: 'A',
      observaciones: 'Observación 5',
      costo: '10.50',
    },
    {
      id: 6,
      nombre: 'Plato6',
      categoria: 'C',
      observaciones: 'Observación 6',
      costo: '22.10',
    },
    {
      id: 7,
      nombre: 'Plato7',
      categoria: 'D',
      observaciones: 'Observación 7',
      costo: '20.50',
    },
    {
      id: 8,
      nombre: 'Plato8',
      categoria: 'A',
      observaciones: 'Observación 8',
      costo: '10.50',
    },
    {
      id: 9,
      nombre: 'Plato9',
      categoria: 'A',
      observaciones: 'Observación 9',
      costo: '22.10',
    },
  ];

  ditinerariosResponse = of(this.itinerarios);

  getAllItineraios(): Observable<any> {
    return this.ditinerariosResponse.pipe(delay(2000));
  }

  getProductById(id: string) {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `query getProductById($id: String!){
        getProductById(id:$id){
    			id,
          nombre,

        }
      }`,
      variables: { id },
    });
  }

  getAllActiveServicesByTypeInFiles(tipoServicio: any) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getAllActiveServicesByTypeInFiles($tipoServicio:String!){
        getAllActiveServicesByTypeInFiles(tipoServicio:$tipoServicio){

          id,
          contador,
          idContador,
          dateRange,
          day,
          idItinerary
          nameClient,
          itineraryId,
          nombreItinerario,
          fileName,
          fileNumber,
          serviceId,
          productId,
          providerId,
          tarifaId,
          day,
          price,
          costo,
          utilidad,
          margen,
          cantPersonal,
          totalCostoSoles,
          totalCostoDolares,
          totalPriceSoles,
          totalPriceDolares
          tipoServicio,
          tipoMoneda,
          nombreServicio,
          observaciones,
          categoriaServicio,
          tipoServicio,
          dateRange,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            pasajero{
              firstName,
              lastName,
              email,
              phone,
              address,
              city,
              state,
              country,
              passportNumber,
              alergias,
              size,
              weight,
              height,
              dateOfBirth,
              age,
              id
              createdAt,
              updatedAt
            }
          },
          objProducto{
            id,
            nombre,
            categoriaProducto,
            subCategoriaProducto
          },
          objProvider{
            id,
            nombre,
            razonSocial,
            tipoProveedor
            condicionesPagos
            {
              condicionPago,
              plazoDiasFit

            }
          },
          estadoFile,
          isDeleted,
          historial
        }
      }`,
      variables: { tipoServicio },
    });
  }

  getItineraryDetailed(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItinerary($id: String!){
        getItinerary(id: $id){
          dateRange
          nombreItinerario,
          usuario,
          paxQuantity,
          estadoItinerario,
          diasItinerario,
          listPassenger,
          totalPriceDolares,
          totalCostoDolares,
          totalUtilidadDolares,
          itinerarioDetalladoId,
          clienteId,
          nameClient,
          archived,
          tipoCambio,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            pasajero{
                  firstName,
                  lastName,
                  email,
                  phone,
                  address,
                  city,
                  state,
                  country,
                  passportNumber,
                  alergias,
                  size,
                  weight,
                  height,
                  dateOfBirth,
                  age,
                  id,
                  createdAt,
                  updatedAt
                  }
            paxMenu{
                menu{
                    id,
                    nombreMenu
                }
                observaciones
              }
          }
          dueDate,
          arrivalDate,
          operator,
          id,
          createdAt,
          updatedAt,
          modelName,
          descripcionEmail,
          estado,
          estadoFile,
          fileName,
          fileNumber,
          isDeleted
    itinerarios{
      dayName,
      dayNumber,
      totalCostDiaDolares,
      totalPriceDiaDolares,
      totalUtilidadDiaDolares,
      services{
        id,
        itineraryId,
        serviceId,
        productId,
        providerId,
        tarifaId,
        day,
        startHour,
        endHour,
        price,
        costo,
        utilidad,
        margen,
         objServicio{
            id,
            nombreServicio,
            destino,
            categoriaServicio,
            tipoServicio,
            createdAt,
            updatedAt
          },
          objProducto{
            id,
            nombre,
            categoriaProducto,
            subCategoriaProducto
          },
          objProvider{
            id,
            nombre,
            razonSocial,
            tipoProveedor
          },
        cantPersonal,
        totalPriceSoles,
        totalPriceDolares,
        tipoMoneda,
        observaciones,
        categoriaServicio,
        nombreServicio,
        tipoServicio
        observaciones,
        incidencias{
          tipoIncidencia,
          reportedBy,
          descIncidencia,
          estado,
          fechaCreated,
          fechaSolved,
          solutionTime,
          acciones
        },
        historial,
        contador,
        idContador,
        isDeleted,
        lstPaX{
          estado,
          Pax,
          grupo,
          acumulado,
          pasajero{
            firstName,
            lastName,
            email,
            phone,
            address,
            city,
            state,
            country,
            passportNumber,
            alergias,
            size,
            weight,
            height,
            dateOfBirth,
            age,
            id,
            createdAt,
            updatedAt
          }
          paxMenu{
            menu{
              id,
              nombreMenu
            },

          }
        }
      }

    }
         }
       }`,
      variables: { id: itineraryId },
    });
  }

  getPassengersByIds({
    passengerIds = [],
    passengerFields = {},
  }: {
    passengerIds: string[];
    passengerFields?: PassengerFields;
  }) {
    if (passengerIds.length === 0) {
      throw new Error('passengerIds array cannot be empty');
    }
    const fieldsString = Object.keys(passengerFields || {})
      .filter((key) => passengerFields[key as keyof typeof passengerFields]) // Only include fields that are true
      .join(', ');

    // Fallback if no fields are specified, though your requirements imply usage of 'fields'
    const finalFields = fieldsString || 'id, firstName, lastName';

    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetPassengersByIds (
        $passengerIds: [String!]!,
        $passengerFields: String
      ) {
        getPassengers(passengerIds: $passengerIds, passengerFields: $passengerFields) {
          ${finalFields}
        }
      }`,
      variables: { passengerIds, passengerFields: finalFields },
    });
  }

  updateItinerary(id: any, itinerary: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateItinerary($id: String!, $itinerary:inputItinerary_Dto!){
         updateItinerary(id:$id, itinerary:$itinerary){
          id
        }
      }`,
      variables: { id, itinerary },
    });
  }

  getItineraryEquipos(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItinerary($id: String!){
        getItinerary(id: $id){
          id,
    			equipos{
           id,
           nombreEquipo,
           marcaEquipo,
           modeloEquipo,
           tallaEquipo,
           valoracionEquipo,
           observacionEquipo,
           cantidad,
           costo,
           categoria
           estado,
          }
          estadoFile,
          dateRange,
          fileName,
          estado,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          itinerarios{
            services{
              id,
              contador,
              serviceId,
              serviceId,
              productId,
              tipoServicio
            }
          }
         }
       }`,
      variables: { id: itineraryId },
    });
  }
}
